import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const RegisteredVehiclesContainer = styled.div`
  display: flex;
  gap: ${spacing.space16};
  margin-top: ${spacing.space16};
  flex-wrap: wrap;

  > div {
    flex: 1 1 calc(50% - ${spacing.space16});
    max-width: calc(50% - ${spacing.space16});
  }

  @media (max-width: ${breakpoints.l}) {
    flex-direction: column;

    > div {
      flex: 1 1 100%;
      max-width: 320px;
    }
  }
`;
